import { proxy } from "valtio";
import { applyTemplateBlocks, resolveAcfBlockName, transformBlockTemplate, transformTemplateToBlocks, } from "./block-templates.js";
export const editorConfigStore = proxy({
    config: null,
    currentBlocksConfig: {},
});
export function configureEditorBlocks(config) {
    const wp = window.wp;
    let hideStyles = document.getElementById("title-hider");
    hideStyles?.remove();
    if (config.hideTitle) {
        hideStyles = document.createElement("style");
        hideStyles.id = "title-hider";
        hideStyles.innerHTML = `
      .edit-post-visual-editor__post-title-wrapper {
        display: none !important;
      }
    `;
        document.head.appendChild(hideStyles);
    }
    if (config.template) {
        setTemplate(config.template);
        if (config.headerTemplate || config.footerTemplate) {
            console.error("You cannot use both a 'template' alongside 'headerBlock'/'footerBlock'. Did you mean to use 'defaultBlocks' instead?");
            return;
        }
    }
    const currentBlocks = wp.data.select("core/block-editor").getBlocks();
    const newBlocks = applyTemplateBlocks(currentBlocks, config);
    wp.data.dispatch("core/block-editor").resetBlocks(newBlocks);
}
/**
 * This call should be placed in blocks/_editor.tsx
 */
export function defineEditorConfig(config) {
    const wp = window.wp;
    editorConfigStore.config = config;
    if (!wp?.blockEditor)
        return;
    updateTemplateConfig();
}
export function getEditingPostInfo() {
    const post = wp.data.select("core/editor").getCurrentPost();
    const edits = wp.data.select("core/editor").getPostEdits();
    const postInfo = {
        ...post,
        ...edits,
        isTemplatePart: false,
        isPattern: false,
    };
    if (!postInfo.template)
        postInfo.template = "default";
    postInfo.template = postInfo.template.replace(/(^views\/|\.tsx?$)/g, "");
    if (postInfo.type === "wp_template_part") {
        postInfo.isTemplatePart = true;
    }
    if (postInfo.type === "wp_block") {
        postInfo.isPattern = true;
    }
    return postInfo;
}
export function updateTemplateConfig() {
    const wp = window.wp;
    const postInfo = getEditingPostInfo();
    const editorConfig = editorConfigStore.config;
    if (!editorConfig)
        return;
    const matched = editorConfig.matchers?.find((matcher) => {
        return matcher.match(postInfo);
    });
    if (matched) {
        const config = typeof matched.config === "function" ? matched.config(postInfo) : matched.config;
        editorConfigStore.currentBlocksConfig = config;
        configureEditorBlocks(config);
    }
    else {
        editorConfigStore.currentBlocksConfig = {};
        configureEditorBlocks({});
    }
}
export function watchEditorTemplate() {
    let lastKey = "unknown";
    let timer = 0;
    const update = () => {
        const post = wp.data.select("core/editor").getCurrentPost();
        const template = wp.data.select("core/editor").getPostEdits()?.template ?? post?.template ?? "";
        const key = [post.type, template, post.slug, post.title].join(";");
        if (key !== lastKey) {
            lastKey = key;
            clearTimeout(timer);
            timer = setTimeout(() => {
                updateTemplateConfig();
            }, 20);
        }
    };
    wp.data.subscribe(() => {
        update();
    });
    update();
}
function setWrapperBlock(blockName, blocks) {
    const wp = window.wp;
    const dispatch = wp.data.dispatch("core/block-editor");
    const blockWrapperName = blockName ? resolveAcfBlockName(blockName) : null;
    const untemplatedBlocks = blocks.flatMap((block) => {
        if (block.name === blockWrapperName || block.attributes.isFromTemplate) {
            return block.innerBlocks.filter((innerBlock) => !innerBlock.attributes.isFromTemplate);
        }
        return block;
    });
    let newBlocks = [...untemplatedBlocks];
    if (blockName) {
        const rootId = "block-" + Math.random().toString(36);
        const parent = {
            clientId: rootId,
            name: blockWrapperName,
            validationIssues: [],
            isValid: true,
            attributes: { data: {}, inline: {}, isFromTemplate: true, lock: { move: true, remove: true } },
            innerBlocks: [
                {
                    clientId: rootId + "-inner",
                    name: "core/group",
                    validationIssues: [],
                    isValid: true,
                    attributes: { data: {}, inline: {}, isFromTemplate: true, lock: { move: true, remove: true } },
                    innerBlocks: untemplatedBlocks,
                },
            ],
        };
        wp.data.dispatch("core/block-editor").resetBlocks([parent]);
        wp.data.dispatch("core/block-editor").updateSettings({
            templateLock: "contentOnly",
        });
        wp.data.dispatch("core/block-editor").setBlockEditingMode(rootId, "disabled");
        wp.data.dispatch("core/block-editor").setBlockEditingMode(rootId + "-inner", "default");
    }
    else {
        wp.data.dispatch("core/block-editor").resetBlocks(newBlocks);
    }
    // wp.data.dispatch('core/block-editor').setBlockEditingMode(wp.data.select('core/block-editor').getBlocks()[0].clientId, '')
}
function setTemplate(template) {
    const wp = window.wp;
    let currentBlocks = wp.data.select("core/block-editor").getBlocks();
    wp.data.dispatch("core/block-editor").updateSettings({
        templateLock: "all",
        template: transformBlockTemplate(template),
    });
    if (currentBlocks?.length === 0) {
        setTimeout(() => {
            wp.data.dispatch("core/block-editor").resetBlocks(transformTemplateToBlocks(template));
            wp.data.dispatch("core/block-editor").setTemplateValidity(true);
        }, 1);
        return;
    }
    wp.data.dispatch("core/block-editor").validateBlocksToTemplate(currentBlocks);
}
